import { Pipe, PipeTransform } from '@angular/core';
import { StatistikYdelserToListViewModel } from '../../models/StatistikYdelser';

@Pipe({
    name: 'ydelseTimerKroner',
    standalone: false
})
export class YdelseTimerKronerPipe implements PipeTransform {
    transform(ydelser: StatistikYdelserToListViewModel[], ydelseId: number, hourFormat: string): any {
        const ydelse = ydelser.find(y => y.v2YdelserId === ydelseId);
        if (hourFormat === 'Timer') { return ydelse.timer; }
        return ydelse.kroner;
    }
}
